import { useMediaQuery, useTheme } from "@mui/material";

export default function useIsSmUp() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  return isSmUp;
}
